export default __webpack_public_path__ + "static/media/cs.04f199aa.md";